module.exports = __webpack_public_path__ + "img/thumbnail_CommonWombat_m_albino.e85b8d58.png";